import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const Text = ({ content, isActive, className }) => {
  return (
    <div
      data-testid="content"
      className={cn({ [styles.contentActive]: isActive }, styles.tabContent, className)}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

Text.propTypes = {
  content: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

Text.defaultProps = {
  className: '',
};

export default Text;
